module.exports = __webpack_public_path__ + "static/img/new-2.1.fb1f7ba4.jpg";